import React, { FC, useRef, useEffect } from "react"
import { useCreation } from "ahooks"
import { EChartOption } from "echarts"
import Echart from "@components/Echart"
import Env from "@util/env"
import "echarts-wordcloud"
import "./index.scss"

type IGraphProps = {
  data: { value: number; name: string }[]
}
const color = ["#5886F8", "#F8C969", "#00FCEF", "#F8775A", "#BD81DE"]
const colorLen = color.length
const WorldCloud: FC<IGraphProps> = ({ data }) => {
  const ref = useRef()
  const option = useCreation<EChartOption>(() => {
    return {
      tooltip: { show: false },
      series: [
        {
          type: "wordCloud",
          gridSize: 1,
          textPadding: 0,
          sizeRange: [12 * Env.getScale(), 40 * Env.getScale()],
          rotationRange: [-90, 90],
          shape: "diamond", //circle, diamond, cardioid triangle-forward, triangle,
          width: "100%",
          height: "100%",
          drawOutOfBound: false,
          textStyle: {
            normal: {
              color: function () {
                return color[Math.floor(Math.random() * colorLen)]
              },
            },
            emphasis: {
              shadowBlur: 10,
              shadowColor: "#333",
            },
          },
          data: data,
        },
      ],
    }
  }, [data])
  useEffect(() => {
    return () => {
      // @ts-ignore
      ref.current && ref.current.getEchartsInstance().dispose()
    }
  }, [ref])
  return (
    <div className="ct-tree-map" style={{ height: "100%" }}>
      <Echart $ref={ref} option={option} />
    </div>
  )
}

export default WorldCloud
